import React from 'react';

import Popup from '../Popup/Popup';
import { isMobileWidth } from '../../theme/layout-utils';
import LeadGenForm from '../LeadGenForm/LeadGenForm';

const LeadGenModal = ({ open, onClose, popupID }) => {
    const modalStyle = {
        width: '375px',
        padding: '0',
        overflow: 'auto',
        zIndex: '10000',
        background: 'transparent',
        border: 'none'
    };

    const modalMobileStyle = {
        height: '100vh',
        width: '100%',
        padding: '0',
        overflow: 'scroll',
        zIndex: '10000'
    };

    return (
        <React.Fragment>
            {/* INTERSTITIAL MODAL */}

            <Popup
                open={open}
                onClose={onClose}
                closeOnEscape
                contentStyle={isMobileWidth() ? modalMobileStyle : modalStyle}
                overlayStyle={{ zIndex: '10000', overflow: 'auto' }}
                popupID={popupID}
            >
                <LeadGenForm showInModal onClose={onClose} />
            </Popup>
        </React.Fragment>
    );
};

export default LeadGenModal;



// WEBPACK FOOTER //
// ./src/components/LeadGenModal/LeadGenModal.js